import React from 'react';
import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import useAppContext from 'flow/hooks/useAppContext';

const NotificationPermissionNotifier = () => {
    const { i18next } = useAppContext();
    const onAccept = () => {
        window.open(window.location.origin, '_blank');
    };

    return (
        <NotifierBanner
            theme={'warning'}
            message={i18next.t('notifier.permissions.notifications.message')}
            buttonText={i18next.t(
                'notifier.permissions.notifications.button_text',
            )}
            handleClick={onAccept}
        />
    );
};

export default NotificationPermissionNotifier;
